import { RootPaths } from "../App/paths";

export const URGENT_SHIFTS_PATH = `${RootPaths.HOME}/urgentShifts`;

export const OPEN_SHIFT_PATH = "openShifts";
